import type { PulseEvent } from './pulseApi'
import PulseTimeline from './PulseTimeline'
import { last14DaysIso, whatChangedEmptyLine } from './pulseWhatChanged.js'

function toDatetimeLocal(iso: string) {
  const d = new Date(iso)
  if (!Number.isFinite(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default function PulseWhatChanged({
  since,
  lastVisit,
  events,
  onSince,
  onClose,
  onShow14,
  onOpen,
}: {
  since: string
  lastVisit: string
  events: PulseEvent[]
  onSince: (iso: string) => void
  onClose: () => void
  onShow14: () => void
  onOpen: (event: PulseEvent) => void
}) {
  const empty = events.length === 0
  return (
    <div className="pulse-changed-panel" data-testid="pulse-what-changed-panel" role="dialog" aria-label="What changed">
      <div className="pulse-changed-head">
        <label className="pulse-changed-since">
          Since
          <input
            type="datetime-local"
            aria-label="Since date"
            data-testid="pulse-since"
            value={toDatetimeLocal(since)}
            onChange={(e) => onSince(e.target.value ? new Date(e.target.value).toISOString() : since)}
          />
        </label>
        <button type="button" className="btn b-ol btn-sm" data-testid="pulse-what-changed-close" onClick={onClose}>Close</button>
      </div>
      {empty ? (
        <div data-testid="pulse-what-changed-empty">
          <p>{whatChangedEmptyLine(lastVisit || since)}</p>
          <button
            type="button"
            className="btn b-ol btn-sm"
            data-testid="pulse-what-changed-14d"
            onClick={() => { onSince(last14DaysIso()); onShow14() }}
          >
            Show last 14 days
          </button>
        </div>
      ) : (
        <PulseTimeline events={events} onOpen={onOpen} onReset={onClose} />
      )}
    </div>
  )
}
